module.exports = __webpack_public_path__ + "static/media/mamorepo02.b55a51c4.jpg";